import { HighlightedProduct } from "src/features/highlighted-product/model/HighlightedProduct";
import projectOptions from "src/shared/project-options";

const getCombinedDetail = (
  data: HighlightedProduct[],
  displayIndex: number = 0
) => {
  const displayedProduct = data[displayIndex];
  const combines = displayedProduct?.combines ?? [];
  const { eventId } = projectOptions.default.network;
  const [combinedDetail] = combines.filter(
    (combined) => combined.event === +eventId
  );
  const thumbnails = data
    .map((product, index) => {
      return { displayIndex: index, imageUrl: product.imageUrl };
    })
    .filter((product, index) => index !== displayIndex);

  // get the highest and lowest price
  const highestPrice = Math.max(...data.map((product) => +product.price));
  const lowestPrice = Math.min(...data.map((product) => +product.price));
  // put it in a tuple
  const priceRange: [number, number] = [lowestPrice, highestPrice];

  return {
    ...combinedDetail,
    combinedCount: data?.length,
    thumbnails,
    priceRange,
  };
};

export default getCombinedDetail;
